/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FilestoreAttachment } from './FilestoreAttachment';
import {
    FilestoreAttachmentFromJSON,
    FilestoreAttachmentFromJSONTyped,
    FilestoreAttachmentToJSON,
} from './FilestoreAttachment';

/**
 * 
 * @export
 * @interface WorkerPhoneHomeResponse
 */
export interface WorkerPhoneHomeResponse {
    /**
     * 
     * @type {string}
     * @memberof WorkerPhoneHomeResponse
     */
    schedulerAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerPhoneHomeResponse
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkerPhoneHomeResponse
     */
    schedulerReady: boolean;
    /**
     * 
     * @type {Array<FilestoreAttachment>}
     * @memberof WorkerPhoneHomeResponse
     */
    filestoreAttachments?: Array<FilestoreAttachment>;
}

/**
 * Check if a given object implements the WorkerPhoneHomeResponse interface.
 */
export function instanceOfWorkerPhoneHomeResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "schedulerReady" in value;

    return isInstance;
}

export function WorkerPhoneHomeResponseFromJSON(json: any): WorkerPhoneHomeResponse {
    return WorkerPhoneHomeResponseFromJSONTyped(json, false);
}

export function WorkerPhoneHomeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkerPhoneHomeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'schedulerAddress': !exists(json, 'scheduler-address') ? undefined : json['scheduler-address'],
        'name': json['name'],
        'schedulerReady': json['scheduler-ready'],
        'filestoreAttachments': !exists(json, 'filestore_attachments') ? undefined : ((json['filestore_attachments'] as Array<any>).map(FilestoreAttachmentFromJSON)),
    };
}

export function WorkerPhoneHomeResponseToJSON(value?: WorkerPhoneHomeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'scheduler-address': value.schedulerAddress,
        'name': value.name,
        'scheduler-ready': value.schedulerReady,
        'filestore_attachments': value.filestoreAttachments === undefined ? undefined : ((value.filestoreAttachments as Array<any>).map(FilestoreAttachmentToJSON)),
    };
}

